<template>
  <div class="search">
    <div class="search-header">
      <div class="search-input">
        <i class="iconfont icon-sousuo"></i>
        <input
          ref="input"
          type="search"
          v-focus
          autofocus
          placeholder="请输入您想找的型号"
          name="keys"
          v-model="value"
          v-on:input="getResult"
        >
      </div>
      <div class="fl search-btn">
        <router-link to="/mobile/category">取消</router-link>
      </div>
    </div>
    <h2>热门搜索</h2>
    <div class="hotlist">
      <span v-for="item in hotword" @click="getWord(item)" :key="item.goodsId">{{item}}</span>
    </div>
    <div class="lists" v-if="show">
      <div class="item clearfix" v-for="item in goods" :key="item.goodsId">
        <router-link :to="{name:'mobileOldProductId',params:{id:item.goodsId}}">
          <span class="name">{{item.goodsName}}</span>
          <span class="price">
            <span class="text">回收均价</span>
            <em>{{item.shopPrice}} 元</em>
          </span>
        </router-link>
      </div>
    </div>
    <div class="nolist" v-if="nolist">
      <p>没有找到"{{value}}"相关的机型.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Search",
  data() {
    return {
      value: "",
      results: [],
      show: false,
      nolist: false,
      hotword: [
        "苹果 iPhoneXs Max",
        "苹果 iPhone XR",
        "苹果 iPhone Xs",
        "苹果 iPhone X",
        "苹果 iPhone 7 Plus",
        "苹果 iPhone 8 Plus",
        "苹果 iPhone 6S Plus",
        "苹果 iPhone 7"
      ]
    };
  },
  computed: {
    goods() {
      return this.$store.state.oldproduct.products.products;
    }
  },
  mounted: function() {
    this.$refs["input"].focus();
  },
  methods: {
    getResult() {
      this.results = [];
      let params = {
        size: 10,
        keyword: this.value,
        order: 3
      };
      this.$store.dispatch("oldproduct/fetchProductList", { params }).then(() => {
        if (this.goods.length) {
          this.show = true;
          this.nolist = false;
        } else {
          this.nolist = true;
          console.log("您搜索的型号不存在!");
        }
      });
    },
    getWord(value) {
      this.value = value;
      this.getResult();
    }
  },
  created() {},
  directives: {
    focus: {
      // 指令的定义
      inserted: function(el) {
        el.focus();
      }
    }
  }
};
</script>
<style scoped>
.search {
  background: #f8f8f8;
  width: 100%;
  height: 100%;
  font-size: 0.12rem;
  overflow: hidden;
}
.search .hotlist {
  background-color: #fff;
  padding: 0.05rem;
}
.search .hotlist span {
  margin: 0.05rem;
  font-size: 0.12rem;
  display: inline-block;
  border-radius: 2px;
  border: solid #e2e2e2 1px;
  padding: 0.02rem 0.1rem;
}
.search .lists {
  position: fixed;
  background-color: #fff;
  width: 100%;
  height: 100%;
  top: 0.48rem;
  left: 0;
}
.search h2 {
  font-size: 0.14rem;
  font-weight: normal;
  padding: 0.05rem 0.1rem;
}
.search .lists .item {
  width: 96%;
  height: 0.5rem;
  overflow: hidden;
  line-height: 0.5rem;
  padding: 0 2%;
  border-bottom: solid #e2e2e2 1px;
}
.search .lists .item .name {
  float: left;
  width: 60%;
  font-size: 0.16rem;
}
.search .lists .item .price {
  float: right;
  width: 15%;
  display: inline-block;
  font-size: 0.12rem;
  line-height: 0.2rem;
  text-align: left;
  margin-top: 0.1rem;
}
.search .lists .item .price em {
  display: block;
  font-style: normal;
  color: #f23030;
}
.search .search-header {
  height: 0.48rem;
  background: #efefef;
  display: flex;
  flex-wrap: wrap;
}
.search .search-header .search-input {
  position: relative;
  width: 3.25rem;
}
.search .search-header .search-btn {
  line-height: 0.48rem;
  text-align: center;
  width: 0.5rem;
}
.search .search-header .search-btn a {
  color: #108ee9;
  font-size: 0.14rem;
}
.search .search-header input {
  width: 100%;
  border-radius: 2px;
  border: 0;
  outline: none;
  background: #fff;
  height: 0.3rem;
  line-height: 0.4rem;
  font-size: 0.14rem;
  margin: 0.08rem 0rem;
  padding-left: 0.36rem;
}
.search .search-input .icon-sousuo {
  position: absolute;
  left: 0.1rem;
  top: 0.14rem;
  font-size: 0.18rem;
  color: #000;
}
.search .nolist {
  position: fixed;
  background-color: #fff;
  width: 100%;
  height: 100%;
  top: 0.48rem;
  left: 0;
}
.search .nolist p {
  text-align: center;
  margin: 1rem auto;
}
</style>